/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationStatisticsResponse {
    getFixupPrototypeFunction() { return UtilizationStatisticsResponse.fixupPrototype; }

    static newInstance(model: Partial<UtilizationStatisticsResponse>): UtilizationStatisticsResponse {
        let obj = Object.assign(new UtilizationStatisticsResponse(), model);
        UtilizationStatisticsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationStatisticsResponse>): UtilizationStatisticsResponse {
        if (!model) return null;
        return UtilizationStatisticsResponse.newInstance(<UtilizationStatisticsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationStatisticsResponse) {
        if (!obj) return;

        models.UtilizationStatisticsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationStatisticsResponse): boolean {
        Object.setPrototypeOf(obj, UtilizationStatisticsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_resources === undefined) {
            this.total_resources = 0;
        }
        if (this.patch_readiness_status) {
            models.PatchReadinessStatistics.fixupPrototype(this.patch_readiness_status);
        }
        if (this.overall_statistics) {
            for (let val of this.overall_statistics) {
                models.IndividualKpiBase.fixupPrototype(val);
            }
        }
    }

    /**
     * Indicates whether the tenant level configuration is done or not.
     */
    configured: boolean;

    /**
     * Total number of resources for which the dashboard needs to present the data.
     */
    total_resources: number;

    /**
     * A statistical Data for the Kpi metrics at the selected tenant level.
     */
    overall_statistics: Array<models.IndividualKpiBase>;

    /**
     * Details Describing the Patch readiness Kpi metrics.
     */
    patch_readiness_status: models.PatchReadinessStatistics;

}
